import { useDispatch } from "react-redux";
import { pick } from "lodash";

import { createListingAgentMatchConnection } from "../../../slices/contactFormSlice";
import { useAgentMatchData } from "../../agentMatchHooks";
import { useContactFormData } from "../useContactFormData";

export const useContactFormBehavior = () => {
  const dispatch = useDispatch();
  const agentProps = [
    "agentImageSrc",
    "agentName",
    "agentTitle",
    "brokerage",
    "brokerageAddress",
    "contactId",
    "isPro",
    "medianSalesPrice",
    "nearbyHomes",
    "profileUrl",
    "propertyId",
    "recentHomesSold",
    "similarHomes",
    "soldHomesInUserBuilding",
    "uuid",
    "yearsExperience"
  ];
  const agent = useAgentMatchData();
  const { propertyId, saleId, userId } = useContactFormData();
  const agentData = pick(agent, agentProps);

  return {
    createListingAgentMatchConnection: formData =>
      dispatch(
        createListingAgentMatchConnection({
          ...agentData,
          ...formData,
          propertyId,
          userId,
          saleId
        })
      )
  };
};
